import { Modal } from 'antd';
import { useEffect } from 'react';

const modalType = {
  modalSmall: { width: 480 }, // 一号弹窗
  modalMiddle: { width: 580 }, // 二号弹窗
  modalMiddlePro: { width: 850 }, // 二号弹窗
  modalLarge: { width: '90vw' }, // 三号弹窗
};

export default function ModalGlobal(props) {
  useEffect(() => {
    if (props?.isKeydown) {
      const keydown = (event) => {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
          if (props?.onOk) {
            props.onOk();
          }
        }
      };

      window.addEventListener('keydown', keydown);
      return () => {
        window.removeEventListener('keydown', keydown);
      };
    }
  }, []);

  return (
    <Modal
      title={props?.title}
      open={props?.open}
      maskClosable={false}
      {...modalType[props.type || 'modalSmall']}
      onOk={() => {
        if (props?.onOk) {
          props.onOk();
        }
      }}
      onCancel={() => {
        if (props?.onCancel) {
          props.onCancel();
        }
      }}
      {...props.modalSettings}
    >
      {props.children}
    </Modal>
  );
}

export { modalType };
